export const openUrl = (url) => {
    if (window.navigator && window.navigator.msSaveOrOpenBlob) { // IE
        var xhr = new XMLHttpRequest()
        xhr.open('GET', url, true)
        xhr.responseType = 'blob'
        xhr.onload = function (e) {
            if (xhr.readyState === 4) {
                if (xhr.status === 200) {
                    window.navigator.msSaveOrOpenBlob(xhr.response)
                }
                else
                    console.error(xhr.statusText)
            }
        }
        xhr.onerror = function (e) {
            console.error(xhr.statusText)
        }
        xhr.send(null)
    }
    else
        window.open(url, '_blank')
}


// WEBPACK FOOTER //
// ./src/shared/utils/openUrl.js